import { TreatmentModel } from 'src/components/messages/treatmentsModel';

class PatientTreatmentsModel extends TreatmentModel {
  id = 'PatientTreatmentsModel';
  constructor() {
    super();
  }
  _events = {
    profile: 'handleProfile',
    openPatient: 'onOpenPatient',
    'foxsocket:message:treatment': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  listParams(loadMore) {
    const req = super.listParams(loadMore);

    if (!req) return null;

    return {
      ...req,
      patientId: req.partnerId
    };
  }
  onOpenPatient = (patient = null) => {
    if (!patient?.id) return;

    this.onOpenContact({
      contact: {
        ...patient,
        partnerId: patient.id
      }
    });
  };
}
const treatmentsModel = new PatientTreatmentsModel();

export default treatmentsModel;
